import useMartyContext from 'hooks/useMartyContext';
import MicrosoftAdsProduct from 'components/search/MicrosoftAdsProduct';
import { getLowStockLabelStatus } from 'helpers/cardUtils';

const MicrosoftAdsWrapper = ({ msftResults, msaImageParams, trackMicrosoftAdImpressions, makeMicrosoftAdClick, numMicrosoftAds, msftAdsToShow, CardBottomSlot }) => {
  const { marketplace: { search: { hasStyleRoomFlag } } } = useMartyContext();

  if (!msftAdsToShow) {
    return null;
  }

  return msftResults.results.map((props, i) => {
    const product = { ...props, index: i, isSponsored: true };
    const { styleId, colorId } = product;
    product.isLowStock = getLowStockLabelStatus({ ...product, hasStyleRoomFlag });
    return styleId && colorId && <MicrosoftAdsProduct
      key={`${styleId}-${colorId}`}
      product={product}
      numMicrosoftAds={numMicrosoftAds}
      trackMicrosoftAdImpressions={trackMicrosoftAdImpressions}
      makeMicrosoftAdClick={makeMicrosoftAdClick}
      msaImageParams={msaImageParams}
      CardBottomSlot={CardBottomSlot}
    />;
  });
};

export default MicrosoftAdsWrapper;
